<div id="uploadingDialog" appDraggable dragTarget="#uploadingDialog" dragHandle="#uploadingDialogHeader" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" >
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div id="uploadingDialogHeader" class="modal-header">
				<h4 class="modal-title">UPLOADING MAP...</h4>
			</div>
			<div class="modal-body">
				<img src="assets/images/indefinite-progress.gif" style="max-width: 40px; max-height: 40px" />
			</div>
		</div>
	</div>
</div>